module.exports = __webpack_public_path__ + "static/media/mapIcon.47640f2c.svg";